"use strict";

var pack = function pack() {
  for (var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++) {
    items[_key] = arguments[_key];
  }

  return Buffer.concat(items.map(function (type) {
    return type.toBuffer();
  }));
};

module.exports = {
  pack: pack
};